<script setup>

const emit = defineEmits(["click"]);

const props = defineProps({
    loading: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <v-card class="d-flex justify-content-end">
        <v-btn
            :loading="props.loading"
            :disabled="props.disabled"
            type="submit"
            class="btn-success"
            @click.stop="emit('click')"
        >
            {{ $t('common.labels.save') }}
        </v-btn>
    </v-card>
</template>



<style lang="scss" scoped>
.trezo-card{
    margin-bottom: -15px;

    button,
    a {
        margin: {
            right: 15px;
            bottom: 15px;
        }
        display: inline-block !important;
        padding: 14px 35px !important;
        width: auto;
        height: auto;
        font: {
            size: var(--fontSize) !important;
            weight: 500 !important;
        }
        &.v-btn--icon {
            width: 56px;
            height: 56px;
            padding: 0 !important;
            color: var(--whiteColor);
        }
        &.trezo {
            color: var(--primaryColor);
        }
        &.fw-bold {
            font-weight: 700 !important;
        }
        &.fw-semibold {
            font-weight: 600 !important;
        }
        &.d-block {
            text-align: center !important;
            display: block !important;
            width: 100% !important;
        }
    }
}
</style>
